import React from 'react';

import Layout from '../components/Layout';

const IndexPage = () => (
  <Layout>
    <article id="main">
      <header>
        <h2>Contáctanos</h2>
      </header>
      <section className="wrapper style5">
        <div className="inner">
          <section>
            <h4>Llena tus datos</h4>
            <form method="post" action="">
              <div className="row gtr-uniform">
                <div className="col-6 col-12-xsmall">
                  <input
                    type="text"
                    name="demo-name"
                    id="demo-name"
                    defaultValue=""
                    placeholder="Nombre"
                  />
                </div>
                <div className="col-6 col-12-xsmall">
                  <input
                    type="email"
                    name="demo-email"
                    id="demo-email"
                    defaultValue=""
                    placeholder="Email"
                  />
                </div>
                <div className="col-12">
                  <select name="demo-category" id="demo-category">
                    <option value="">- Servicio requerido -</option>
                    <option value="1">Servicio de consultoría </option>
                    <option value="1">
                      Desarrollo de sistemas informáticos{' '}
                    </option>
                    <option value="1">Servicio de capacitación </option>
                  </select>
                </div>
                <div className="col-12">
                  <textarea
                    name="demo-message"
                    id="demo-message"
                    placeholder="Ingresa un mensaje"
                    rows="6"
                  ></textarea>
                </div>
                <div className="col-12">
                  <ul className="actions">
                    <li>
                      <input
                        type="submit"
                        value="Enviar mensaje"
                        className="primary"
                      />
                    </li>
                    <li>
                      <input type="reset" value="Limpiar campos" />
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          </section>
        </div>
      </section>
    </article>
  </Layout>
);

export default IndexPage;
